import { render } from "./OrderCard.vue?vue&type=template&id=58fae87c&scoped=true"
import script from "./OrderCard.vue?vue&type=script&lang=js"
export * from "./OrderCard.vue?vue&type=script&lang=js"

import "./OrderCard.vue?vue&type=style&index=0&id=58fae87c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58fae87c"]])

export default __exports__